import { render, staticRenderFns } from "./GroupAccesRevoker.vue?vue&type=template&id=c9597264&scoped=true"
import script from "./GroupAccesRevoker.vue?vue&type=script&lang=js"
export * from "./GroupAccesRevoker.vue?vue&type=script&lang=js"
import style0 from "./GroupAccesRevoker.vue?vue&type=style&index=0&id=c9597264&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9597264",
  null
  
)

export default component.exports